import { useState } from 'react';
import { deletePassport, getPassport, savePassport } from '@/dom/passportStorage';
import type { FitPassport } from '@/types/passport';

export function useFitPassport() {
  const [passport, setPassport] = useState<FitPassport | null>(() => getPassport());

  function save(next: FitPassport) {
    const withTimestamp: FitPassport = { ...next, updatedAt: new Date().toISOString() };
    savePassport(withTimestamp);
    setPassport(withTimestamp);
  }

  function remove() {
    deletePassport();
    setPassport(null);
  }

  return { passport, save, remove };
}
